"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expose = exports.getExposedProperties = void 0;
const exposedProperties = Symbol('exposedProperties');
const getExposedProperties = (target) => {
    return target[exposedProperties] || target.prototype[exposedProperties] || [];
};
exports.getExposedProperties = getExposedProperties;
/**
 * Indicates that a class member function can be exposed using {@link ApiExposer}.
 * @param options Options specific to the strategy used in {@link ApiExposer}
 */
// Returns any as decorator typing is weird.
const expose = (options) => (target, key, descriptor) => {
    target[exposedProperties] = target[exposedProperties] || [];
    target[exposedProperties].push({ key, descriptor, options });
};
exports.expose = expose;
